var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-social"},[_c('button',{staticClass:"btn btn-lg btn-facebook",on:{"click":function($event){_vm.doLogin('facebook')}}},[_c('i',{staticClass:"fab fa-facebook"})]),_c('button',{staticClass:"btn btn-lg btn-google",on:{"click":function($event){_vm.doLogin('google')}}},[_c('i',{staticClass:"fab fa-google"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37ea0634","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/LoginSocial.vue
// module id = null
// module chunks = 